import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router';
import { useTypedSearchParams } from 'react-router-typesafe-routes';
import ScanImage from '@/assets/images/icons/scan.svg?react';
import QrCodeView from '@/components/common/qr-code-view';
import { SafeImage } from '@/components/common/safe-image';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import LoadingLayout from '@/components/layouts/progress-layout/loading-layout';
import { useCommDispatcher } from '@/hooks/comm/use-comm';
import useUserInfo from '@/hooks/users/use-user-info';
import useUserQrCode from '@/hooks/users/use-user-qrcode';
import ROUTES from '@/routes';

export default function MyQRCodeRoute() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useTypedSearchParams(ROUTES.MY.QR_CODE);
  const { data: userInfo, isLoading: isUserInfoLoading } = useUserInfo();
  const { data: qrcode, isLoading: isUserQrCodeLoading } = useUserQrCode();
  const { dispatch } = useCommDispatcher();
  const isLoading = isUserInfoLoading || isUserQrCodeLoading;

  return (
    <PageLayout
      title={t('personal-info.qr-code')}
      className='flex min-h-full flex-1 flex-col gap-6'
      headerConfig={{
        navigateBack: true,
        onNavigateBack: () => (searchParams.from === 'onboard' ? dispatch({ event: 'dismiss' }) : undefined),
        headerLabel: t('personal-info.qr-code'),
        actions: (
          <Link
            className='btn btn-square mode-embedded:btn-sm btn-ghost'
            to={ROUTES.CONTACT.REQUEST.SCAN.$path()}>
            <ScanImage className='size-6' />
          </Link>
        ),
      }}
      blockOnDesktop>
      <LoadingLayout promise={isLoading}>
        {() =>
          qrcode ? (
            <QrCodeView
              data={qrcode}
              label={userInfo?.NickName}
              avatarUrl={userInfo?.HeadImg}
              onForward={(url) => {
                navigate(ROUTES.MY.QR_CODE.$.SHARE.$buildPath({ relative: true, searchParams: { code: url } }));
              }}
            />
          ) : null
        }
      </LoadingLayout>
    </PageLayout>
  );
}
